import TransportesService from '@/services/TransportesService'

export const transportes = {
  namespaced: true,
  actions: {
    totalPassageirosSPTransTransportadosSazonal ({ dispatch }) {
      return TransportesService.totalPassageirosSPTransTransportadosSazonal()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    totalPassageirosSPTransEstatisticaMes ({ dispatch }, { dataInicio, dataFim }) {
      return TransportesService.totalPassageirosSPTransEstatisticaMes({ dataInicio, dataFim })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    totalPassageriosSPTransConsolidado ({ dispatch }, { dataInicio, dataFim, agrupamento }) {
      return TransportesService.totalPassageirosSPTransConsolidado({ dataInicio, dataFim, agrupamento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
  },
  state: {},
  mutations: {},
}
